import {Button} from 'platform/components';
import {Hide, HStack, Show} from 'platform/foundation';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface DashboardLayoutActionsProps extends TestIdProps {
  isCustomising: boolean;
  isCustomisationAvailable: boolean;
  onStart: () => void;
  onSave: () => void;
  onCancel: () => void;
  onReset: () => void;
}

export function DashboardLayoutActions(props: DashboardLayoutActionsProps) {
  return (
    <Hide onMobile>
      <Show whenFeatureEnabled={featureFlags.DASHBOARD_CUSTOMISATION}>
        {props.isCustomising ? (
          <HStack spacing={2}>
            <Button
              variant="ghost"
              title={i18n.t('page.homepage.dashboardLayout.resetLayout')}
              onClick={props.onReset}
              data-testid={suffixTestId('resetLayout', props)}
            />
            <Button
              variant="ghost"
              title={i18n.t('general.actions.cancel')}
              onClick={props.onCancel}
              data-testid={suffixTestId('cancelLayout', props)}
            />
            <Button
              variant="primary"
              title={i18n.t('general.actions.save')}
              onClick={props.onSave}
              data-testid={suffixTestId('saveLayout', props)}
            />
          </HStack>
        ) : (
          <Button
            variant="secondary"
            leftIcon="action/dashboard"
            title={i18n.t('page.homepage.dashboardLayout.customise')}
            onClick={props.onStart}
            isDisabled={!props.isCustomisationAvailable}
            data-testid={suffixTestId('customiseLayout', props)}
          />
        )}
      </Show>
    </Hide>
  );
}
